import {create} from 'zustand';

const useViewDocumentModal = create((set) => ({
  isOpen: false,
  open: () => set({isOpen: true}),
  close: () => set({isOpen: false}),
}));


export default useViewDocumentModal;